import { Service } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

export interface ICanDeactivate {
  canDeactivate(): boolean | Promise<boolean> | Observable<boolean>;
}

@Service()
export class MngDeactivationGuard {
  canDeactivate(
    component: ICanDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // console.log('canDeactivate guard');
    if (component.canDeactivate) {
      try {
        const value: boolean | Promise<boolean> | Observable<boolean> = component.canDeactivate();
        return value;
      } catch (e) {
        console.error(e);
        return false;
      }
    } else {
      return true;
    }
  }
}
